import { useMemo } from 'react';
import { css } from '@emotion/react';
import { OperatingSystem } from '@weave/schema-gen-ts/dist/schemas/syncapp/integrations-service/integration.pb';
import { breakpoints } from '@frontend/responsiveness';
import { theme } from '@frontend/theme';
import { Accordion, Text } from '@frontend/design-system';
import { UserRole } from '../../utils/constants';
import { checkRbacAccess, formatString } from '../../utils/helpers';
import { IntegrationsMetadata } from '../../utils/typings';

interface OperatingSystemAccordionProps {
  operatingSystem?: OperatingSystem[];
  integrationsMetadata?: IntegrationsMetadata;
  userRole?: keyof typeof UserRole;
}

const OperatingSystemAccordion = ({
  operatingSystem,
  integrationsMetadata,
  userRole,
}: OperatingSystemAccordionProps) => {
  const hasViewAccess = useMemo(
    () => checkRbacAccess(integrationsMetadata?.operatingSystems, userRole).hasViewAccess,
    [integrationsMetadata, userRole]
  );

  return (
    <Accordion variant='main' showBoxShadow>
      <Accordion.Item value='operating-system'>
        <Accordion.Header>
          <Text weight='bold'>Operating System</Text>
        </Accordion.Header>
        <Accordion.Body css={containerStyle}>
          {operatingSystem && operatingSystem.length > 0 && hasViewAccess ? (
            operatingSystem.map((chip) => <Text key={chip}>{formatString(chip)}</Text>)
          ) : (
            <Text>No Operating System available.</Text>
          )}
        </Accordion.Body>
      </Accordion.Item>
    </Accordion>
  );
};

export default OperatingSystemAccordion;

const containerStyle = css`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: ${theme.spacing(2)};
  align-items: start;

  @media (max-width: ${breakpoints.mobile.min}px) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media (max-width: ${breakpoints.xsmall.max}px) {
    grid-template-columns: 1fr;
  }
`;
